import { SearchApi } from '../../generated/api';
import configuration from './configuration';

export default new SearchApi(configuration);
